import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { micronutrientDisplayOrder, micronutrientLabels } from '../utils/sessionDetailHelpers'

const NutritionTotalsPanel = ({ nutritionTotals, showTotalsMicros, setShowTotalsMicros }) => {
  const microEntries = showTotalsMicros
    ? micronutrientDisplayOrder
        .filter((key) => nutritionTotals.micronutrients?.[key] !== undefined)
        .map((key) => ({ key, label: micronutrientLabels[key] || key, value: nutritionTotals.micronutrients[key] }))
    : []

  return (
    <div className="w-full flex-shrink-0 lg:max-h-[22rem] lg:overflow-y-auto">
      <Card className="border-0 shadow-sm ring-1 ring-slate-200/80">
        <CardHeader className="flex flex-row items-center gap-2 px-4 pt-3 pb-2">
          <CardTitle className="text-base font-semibold text-slate-900">Plan Totals</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2.5 px-4 pt-0 pb-4 text-sm text-slate-700">
          <div className="flex items-center justify-between rounded-md bg-fitness-primary/5 px-3 py-2 font-semibold text-fitness-primary">
            <span>Calories</span>
            <span>{Math.round(nutritionTotals.calories)}</span>
          </div>
          <div className="flex items-center justify-between rounded-md bg-white px-3 py-2 shadow-sm ring-1 ring-slate-200">
            <span>Protein</span>
            <span>
              {Math.round(nutritionTotals.protein)}
              <span className="ml-1 text-xs text-slate-400">g</span>
            </span>
          </div>
          <div className="flex items-center justify-between rounded-md bg-white px-3 py-2 shadow-sm ring-1 ring-slate-200">
            <span>Carbs</span>
            <span>
              {Math.round(nutritionTotals.carbs)}
              <span className="ml-1 text-xs text-slate-400">g</span>
            </span>
          </div>
          <div className="flex items-center justify-between rounded-md bg-white px-3 py-2 shadow-sm ring-1 ring-slate-200">
            <span>Fat</span>
            <span>
              {Math.round(nutritionTotals.fat)}
              <span className="ml-1 text-xs text-slate-400">g</span>
            </span>
          </div>
          <button
            type="button"
            onClick={() => setShowTotalsMicros((prev) => !prev)}
            className="text-xs font-semibold text-fitness-primary hover:text-fitness-primary/80"
          >
            {showTotalsMicros ? 'Hide Micronutrients' : 'Micronutrients'}
          </button>
          {showTotalsMicros &&
            (microEntries.length ? (
              <div className="space-y-1 rounded-lg border border-slate-200 bg-slate-50 p-2">
                {microEntries.map((entry) => (
                  <div key={entry.key} className="flex items-center justify-between text-xs">
                    <span className="text-slate-600">{entry.label}</span>
                    <span className="font-semibold text-slate-800">{Math.round(entry.value)}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-xs text-slate-500">No micronutrient data</div>
            ))}
        </CardContent>
      </Card>
    </div>
  )
}

export default NutritionTotalsPanel
